<script setup lang="ts">
import InfoCardContainer from '../InfoCardContainer.vue';

defineProps<{
  title: string;
  description: string;
}>();
</script>

<template>
  <InfoCardContainer background-color="pink">
    <h3 class="order-guideline-title" :title="title">{{ title }}</h3>
    <p class="order-guideline-description" :title="description">{{ description }}</p>
  </InfoCardContainer>
</template>

<style lang="scss" scoped>
.order-guideline-title {
  width: 50%;

  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.48px;

  margin: 0;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  overflow: hidden;
}

.order-guideline-description {
  font-size: 1rem;
  line-height: 1.3;
  font-weight: 400;

  margin: 0;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  overflow: hidden;
}
</style>
